import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { isBrowser } from '../platform';

const closeCallbacks = [];

function isDescendant(parent, child) {
  if (child === parent) {
    return true;
  } else if (child.parentNode != null) {
    return isDescendant(parent, child.parentNode);
  }
  return false;
}

/**
 * A.k.a. addClickListenerThatAlsoWorksOnIOS
 */
function addClickListener(elm, cb) {
  let moved = false;
  let clicked = false;
  let touched = false;
  const touchmove = () => {
    moved = true;
  };
  const touchstart = () => {
    moved = false;
    clicked = false;
    touched = true;
    elm.addEventListener('touchmove', touchmove);
  };
  const touchend = event => {
    elm.removeEventListener('touchmove', touchmove);
    if (!moved && !clicked) {
      cb(event);
    }
  };
  const click = event => {
    if (touched) {
      return;
    }
    clicked = true;
    cb(event);
  };

  elm.addEventListener('click', click);
  elm.addEventListener('touchstart', touchstart);
  elm.addEventListener('touchend', touchend);

  return () => {
    elm.removeEventListener('click', click);
    elm.removeEventListener('touchstart', touchstart);
    elm.removeEventListener('touchend', touchend);
  };
}

export default function withOnOutsideClick(WrappedComponent) {
  if (!withOnOutsideClick.isActive()) {
    return WrappedComponent;
  }

  class WithOnOutsideClick extends Component {
    static propTypes = {
      onOutsideClick: PropTypes.func,
    };
    componentDidMount() {
      if (!this.props.onOutsideClick) {
        return;
      }

      const elm = ReactDOM.findDOMNode(this);

      const captureBodyClick = event => {
        if (
          !isDescendant(elm, event.target) &&
          typeof this.props.onOutsideClick === 'function'
        ) {
          this.props.onOutsideClick(event);
        }
      };

      closeCallbacks.push(captureBodyClick);

      const removeClickListener = addClickListener(
        withOnOutsideClick.getDocument(),
        captureBodyClick
      );

      this.unBind = () => {
        removeClickListener();
        closeCallbacks.splice(closeCallbacks.indexOf(captureBodyClick), 1);
      };
    }
    componentWillUnmount() {
      if (this.unBind) {
        this.unBind();
      }
    }
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  WithOnOutsideClick.displayName = `withOnOutsideClick(${WrappedComponent.displayName ||
    WrappedComponent.name})`;

  return WithOnOutsideClick;
}

/* istanbul ignore next */
withOnOutsideClick.isActive = () => {
  return isBrowser;
};

/* istanbul ignore next */
withOnOutsideClick.getDocument = () => {
  return document;
};
